// Shared form option constants - extracted from inline arrays to prevent
// unnecessary re-renders and improve maintainability

export const YES_NO = ['Yes', 'No'];
export const YES_NO_PENDING = ['Yes', 'No', 'Pending'];
export const YES_NO_REVIEW = ['Yes', 'No', 'Needs review'];

export const SEX_OPTIONS = ['Male', 'Female', 'Intersex', 'Prefer not to say'];
export const GENDER_OPTIONS = ['Male', 'Female', 'Transgender Male', 'Transgender Female', 'Non-binary', 'Gender Fluid', 'Prefer to self-describe', 'Prefer not to say'];
export const PRONOUN_OPTIONS = ['He/Him/His', 'She/Her/Hers', 'They/Them/Theirs', 'Ze/Hir/Hirs', 'Other (please specify)'];

export const INSURANCE_TYPES = ['Medicaid', 'Medicare', 'Self Pay'];
export const LANGUAGE_OPTIONS = ['English', 'Spanish', 'French', 'Other'];

export const RACE_OPTIONS = ['American Indian or Alaska Native', 'Asian', 'Black or African American', 'Hispanic or Latino', 'Native Hawaiian or Pacific Islander', 'White', 'Two or More Races', 'Prefer not to say'];
export const ETHNICITY_OPTIONS = ['Hispanic or Latino', 'Not Hispanic or Latino', 'Prefer not to say'];
export const MARITAL_OPTIONS = ['Single', 'Married', 'Divorced', 'Separated', 'Widowed', 'Domestic Partnership', 'Prefer not to say'];
export const LIVING_OPTIONS = ['Own home', 'Rent', 'With family', 'Group home', 'Shelter', 'Homeless', 'Other'];

export const ADULT_EMPLOYMENT = ['Full-time', 'Part-time', 'Unemployed', 'Student', 'Retired', 'Disabled', 'Other'];
export const MINOR_SCHOOL = ['Attending school', 'Home schooled', 'Not attending', 'Other'];

export const CONTACT_METHODS = ['Phone', 'Email', 'Fax'];
export const URGENCY_LEVELS = ['Routine', 'Priority', 'Urgent'];
export const REFERRAL_CATEGORIES = [
  { value: 'OMHC', label: 'OMHC (Outpatient Mental Health Clinic)' },
  { value: 'PRP', label: 'PRP (Psychiatric Rehabilitation Program)' },
  { value: 'Both', label: 'Both OMHC and PRP' }
];
export const TIMEFRAME_OPTIONS = ['ASAP', 'Within 7 days', 'Within 14 days', 'Flexible'];
export const REFERRAL_STATUS_OPTIONS = ['New Referral', 'Re-Referral', 'Transfer', 'Step-Down'];
export const INTERNAL_STATUS_OPTIONS = ['Pending', 'Reviewing', 'Need More Info', 'Accepted', 'Not Eligible'];

export const SIGNATURE_INTERNAL_STATUS = ['Accepted', 'Pending', 'Need more information', 'Not eligible'];

export const MINOR_NEEDS = ['Home functioning', 'School functioning', 'Community functioning', 'Behavioral regulation', 'Social functioning', 'Caregiver support', 'Transition from higher LOC', 'Risk of higher LOC'];
